module.exports = __webpack_public_path__ + "img/geofisica_4-3_1024.0ae8e67e.jpg";